import { useScreenBreakpoint } from '@/common/hooks/shared';

import { SideNav } from './SideNav';
import { TopNav } from './TopNav';

export const Navigation = () => {
  const isLargeScreen = useScreenBreakpoint('lg');

  return isLargeScreen ? <SideNav /> : <TopNav />;
};
